import { useRef, useState } from 'react';
import { Select as AntSelect, Tooltip } from 'antd';
import { Controller } from 'react-hook-form';
import arrow_down from 'assets/icons/arrow-down.svg';
import InfoCircleIcon from '../Icons/InfoCircleIcon';
import { HelpInfo } from '.';
import { useTranslation } from 'react-i18next';
import { useHover } from 'ahooks';
const { Option } = AntSelect;

interface Props {
  control: any;
  inputName: string;
  placeholder?: string;
  defaultValue?: string | number;
  error?: any;
  callback?: () => void;
  className?: string;
  arrowIcon?: string;
  options: {
    key: string | number;
    label: string | JSX.Element;
    disabled?: boolean;
    img?: JSX.Element;
    title?: string;
  }[];
  disabled?: boolean;
  helpInfo?: string[];
  showSearch?: boolean;
  selectClassName?: string;
  fetchData?: (val: any) => void;
}

export default function Select({
  control,
  inputName,
  defaultValue,
  error,
  options,
  arrowIcon = arrow_down,
  callback = () => {},
  disabled,
  helpInfo = [],
  showSearch = false,
  className = 'custom-select',
  selectClassName,
  fetchData,
  ...props
}: Props) {
  const { t } = useTranslation();
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);
  const [searchText, setSearchText] = useState<string>('');

  return (
    <Controller
      control={control}
      name={inputName}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <div className={`custom-input`}>
          <AntSelect
            showSearch={showSearch}
            value={value}
            searchValue={searchText}
            onSearch={v => {
              setSearchText(v.trimStart());
              if (fetchData) fetchData(v.trimStart());
            }}
            dropdownClassName={className}
            filterOption={(input, option) => {
              return (
                option?.title?.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            onChange={(v, o) => {
              onChange(v);
              callback();
            }}
            className={
              error?.message
                ? `${selectClassName} error-input`
                : selectClassName
            }
            {...props}
            suffixIcon={
              <img
                style={{ marginRight: 4 }}
                src={arrowIcon}
                alt={'chevron_up'}
              />
            }
            disabled={disabled}
          >
            {options.map(option => (
              <Option
                key={`${option.key}`}
                value={option.key}
                disabled={option.disabled}
                title={option?.title}
              >
                {option.img}
                {option.label}
              </Option>
            ))}
          </AntSelect>
          <div className={'custom-select-tooltip'}>
            <Tooltip
              title={
                error?.message ? (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(error?.message),
                    }}
                  />
                ) : (
                  <HelpInfo helpInfo={helpInfo} />
                )
              }
              overlayClassName={
                error?.message ? 'error-tooltip' : 'help-tooltip'
              }
              placement="topRight"
              color={''}
              arrowPointAtCenter
              trigger={
                window.matchMedia('(any-pointer: coarse)').matches
                  ? 'click'
                  : 'hover'
              }
            >
              <div style={{ display: 'flex' }} ref={hoverRef}>
                {error?.message ? (
                  <InfoCircleIcon />
                ) : helpInfo.length > 0 ? (
                  <InfoCircleIcon type="help" isHover={isHover} />
                ) : null}
              </div>
            </Tooltip>
          </div>
        </div>
      )}
    />
  );
}
